import * as Sentry from '@sentry/browser'
import { getSentryConfig, getSentryUser } from '../lib/sentry'

const sentryConfig = getSentryConfig()
if (sentryConfig) {
  Sentry.init({
    ...sentryConfig,
    integrations: [Sentry.browserTracingIntegration()],
    tracesSampleRate: 0.1,
    allowUrls: [
      /https?:\/\/((wholesale|www)\.)?doll\.com/,
      /https?:\/\/(www\.)?babesociety\.com/,
      /https?:\/\/d1cjavvf9wfh6p\.cloudfront\.net/,
    ],
    ignoreErrors: [
      /window\.webkit\.messageHandlers/,
    ],
  })

  const user = getSentryUser()
  if (user) {
    Sentry.setUser(user)
  }
}

import "controllers"
